import axios from "@/libs/api.request";
// 获取列表
export const getList = (data) => {
  return axios.request({
    url: "/shipments/pakistanPost/index",
    data,
    method: "post",
  });
};

// 导出
export const exportFun = (data) => {
  return axios.request({
    url: "/shipments/pakistanPost/export",
    data,
    method: "post",
  });
};
